/**
 * webhookSecretGrace.ts — WEB-2338.
 *
 * Окно перекрытия при ротации секрета подписи вебхуков: сколько часов после
 * выпуска нового секрета сервер ещё принимает старый, чтобы сервер клиента
 * успел перейти на новый без потери событий.
 *
 * ЗЕРКАЛО серверной константы `DEFAULT_GRACE_HOURS` — она живёт в двух
 * местах и решает, когда старый секрет перестаёт подходить:
 * `backend/src/projects/services/webhook-secret.service.ts` (секрет подписи
 * проекта) и `backend/src/webhooks/services/webhook-endpoint.service.ts`
 * (секрет каждого получателя событий). Кабинет число только ПЕЧАТАЕТ — в
 * подписях ротации на экранах «Вебхуки» и «Подключение приложения».
 *
 * Паритет с сервером держит `webhookSecretGrace.parity.web2338.test.ts`.
 */
export const WEBHOOK_SECRET_GRACE_HOURS = 48;
